<template lang="pug">
    .container
        #contact(v-if="!send")
            h2
                img(src="@/assets/img/photo/contact/contact.svg")
            form.contact-form
                label.form.top
                    h3.left メールアドレス
                    input.text(type="text")
                label.form
                    h3.left お問い合わせ内容
                    textarea.text.textarea(placeholder="ご自由にお書きください")
                .form.check
                    .left
                    .right
                        label.check
                            input(type="checkbox",v-model="check")
                            .checkbox
                                span(v-show="check") ✓
                            | 個人情報の取扱
                        p 
                            | 個人情報の取り扱いにつきましては、プライバシーポリシーに記載しておりますので、ご確認ください。
                            br 
                            | 内容をご確認のうえ「送信する」ボタンをクリックしてください
                        p
                            router-link(to="privacy") プライバシーポリシー
                button(type="button",@click="sending")
                    img.send(src="../assets/img/photo/contact/send.svg")
                    img.arrow(src="../assets/img/photo/contact/arrow.png")
        //- お問合せありがとう表示（どういう処理にするかは考え中）
        #thankyou(v-if="send")
            h2
                img(src="@/assets/img/photo/contact/thankyou.svg")
            p.complete
                img.-pc(src="@/assets/img/photo/contact/complete.svg")
                img.-sp(src="@/assets/img/photo/contact/sp_complete.svg")
            .flower
                img(src="@/assets/img/01.png")
        backtoTop
        footerBlock
</template>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
#contact {
  @include container;

  > h2 {
    text-align: center;
    padding: 128px 0;

    > img {
      width: 96px;
    }
  }

  > .contact-form {
    > .form {
      display: flex;
      flex-wrap: wrap;
      margin: 48px 0;

      &.top {
        margin-top: 0;
      }
      > .left {
        font-weight: normal;
        width: 25%;
        padding: 16px;

        @media #{$phone} {
          width: 100%;
        }
      }

      > .right {
        //font-family: $font-sub;
        color: #4d4d4d;
        > p {
          margin: 24px 0;

          > a {
            color: #808080;
          }
        }
        > .check {
          display: flex;
          user-select: none;
          > input {
            display: none;
          }

          > .checkbox {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 24px;
            width: 24px;
            background: #fff;
            border: 1px solid #e6e6e6;
            margin-right: 8px;

            > span {
              font-size: 24px;
            }
          }
        }
      }

      > .text {
        flex-grow: 1;
        background: #fff;
        padding: 16px;
        font-family: $font-sub;
        box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.1);

        &.textarea {
          height: 320px;
          font-family: $font-main;
        }
      }
    }

    > button {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 72px auto 96px;
      > .send {
        width: 40px;
        margin-bottom: 16px;
      }
      > .arrow {
        width: 48px;
      }
    }
  }
}

#thankyou {
  @include container;
  //margin-top: 128px;
  color: #4d4d4d;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media #{$pc} {
    justify-content: center;
  }

  > h2 {
    text-align: center;
    padding: 128px 0 72px;
    > img {
      width: 99px;
    }
  }
  > .complete {
    text-align: center;
    > .-pc {
      display: none;
      @media #{$pc} {
        display: block;
        width: 480px;
        margin: 0 auto;
      }
    }
    > .-sp {
      width: 320px;
      @media #{$pc} {
        display: none;
      }

      @media #{$phone} {
        width: 90%;
      }
    }
  }
  > .flower {
    padding: 72px 0;
    width: 90px;
    margin: 0 auto;

    > img {
      width: 100%;
    }
  }
}
</style>

<script>
import footerBlock from '@/components/footer-block';
import backtoTop from '@/components/backto-top';
import axios from 'axios';
export default {
  components: {
    footerBlock,
    backtoTop,
  },
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      check: false,
      send: false,
    };
  },
  methods: {
    sending() {
      this.send = !this.send;
    },
  },
};
</script>
